import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import AuthBootstrap from 'features/auth/AuthBootstrap';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  return (
    <ThemeCustomization>
      <AuthBootstrap>
        <RouterProvider router={router} />
      </AuthBootstrap>
    </ThemeCustomization>
  );
}
